import React, { useEffect, useState, } from 'react';
import PropTypes from 'prop-types';

const GENERIC_LOGIN_ERROR = `It looks like the email and/or password you entered is not
recognized. Please double check your credentials or contact your
administrator to request access to Athos`;

const StandaloneAuth = ({ handleTenantSignIn, }) => {
  const iFrameContainerId = 'standalone-auth-container';
  const [ errorMessage, setErrorMessage, ] = useState('');

  useEffect(() => {
    const initAuth = async () => {
      const payitSdk = window.payit;
      if (!payitSdk?.auth) {
        setErrorMessage('Cannot load auth microsite');
        return;
      }

      try {
        const environment = window.AthosConfig?.sdkEnv || 'SANDBOX';

        let code = null;

        const regularParams = new URLSearchParams(window.location.search);
        code = regularParams.get('code');

        // If not found and using hash routing, check hash fragment
        if (!code && window.location.hash) {
          const hashParts = window.location.hash.split('?');
          if (hashParts.length > 1) {
            const hashParams = new URLSearchParams(hashParts[1]);
            code = hashParams.get('code');
          }
        }

        const authConfig = {
          appId: 'athos',
          environment,
          errorMessageOverride: GENERIC_LOGIN_ERROR,
        };

        const tenantSignInConfig = {
          domTargetId: iFrameContainerId,
        };

        if (code) {
          authConfig.federatedAuth = {
            code,
          };
          tenantSignInConfig.federatedAuth = {
            code,
          };
        }

        const payitAuth = await payitSdk.auth(authConfig);
        const response = await payitAuth.payitTenantSignIn(tenantSignInConfig);

        if (response?.responseCode === 1) { // success
          const payload = JSON.parse(response?.data || '{}');
          handleTenantSignIn(payload);
        }
      } catch (error) {
        console.error(error);
        setErrorMessage('An error occurred during authentication');
      }
    };

    initAuth();
  }, [ handleTenantSignIn, ]);

  if (errorMessage) {
    return <p className="text-danger">{errorMessage}</p>;
  }

  return (
    <div id={iFrameContainerId} className="iframeContainer" />
  );
};

StandaloneAuth.propTypes = {
  handleTenantSignIn: PropTypes.func.isRequired,
};

export default StandaloneAuth;
